// Unknown dialog's Concerning picker: the shared <ConcerningsPanel> bound to
// the unknown slice's selection. All tree/label/chip behaviour lives in the
// shared panel so every dialog stays identical.

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { addSelectedConcerning, removeSelectedConcerning } from '../../slices/unknownSlice';
import ConcerningsPanel from './concernings-panel';

interface UnknownConcerningsPanelProps {
    height: number;
    onHide?: () => void;
}

const UnknownConcerningsPanel: React.FC<UnknownConcerningsPanelProps> = ({ height, onHide }) => {
    const dispatch = useDispatch();
    const selectedConcernings = useSelector((state: RootState) => state.unknown.selectedConcernings);

    return (
        <ConcerningsPanel
            height={height}
            onHide={onHide}
            selectedConcernings={selectedConcernings}
            onToggleConcerning={(concerningId) => {
                if (selectedConcernings.includes(concerningId)) {
                    dispatch(removeSelectedConcerning(concerningId));
                } else {
                    dispatch(addSelectedConcerning(concerningId));
                }
            }}
        />
    );
};

export default UnknownConcerningsPanel;
